import { useId } from "react";
import { Col, Input, Label } from "reactstrap";
import "./style.css";

export function Checkbox({
  data,
  label,
  name,
  children,
  size = 6,
  ...props
}) {
  let handleBlur = data?.handleBlur;
  const id = useId();

  return (
    <Col lg={size} key="descriptionField">
      <div className="form-check checkbox-wrapper">
        <Input
          id={id}
          name={name}
          type="checkbox"
          className="form-check-input"
          onChange={data?.handleChange}
          onBlur={handleBlur}
          checked={data?.values[name]}
          value={data?.values[name]}
          invalid={data?.touched[name] && data?.errors[name]}
          {...props}
        >
          {children}
        </Input>

        <Label className="form-check-label" htmlFor={id}>{label}</Label>
      </div>
    </Col>
  );
}
